import React, { useState } from "react";
import PropTypes from "prop-types";

const OpsCoreSetup = ({ onExecute, disabled }) => {
  const [vertical, setVertical] = useState("cp_personal_care");
  const [reportFiles] = useState({});

  const createCompany = () => {
    onExecute({
      vertical,
      reportFiles,
    });
  };

  const updateVertical = (evt) => {
    setVertical(evt.target.value);
  };

  return (
    <div className="card" style={{ marginBottom: "24px" }}>
      <div className="card-body">
        <h3 className="card-title">2. Create Shop Floor Company</h3>
        <div className="card-text">
          <div className="form-group">
            <div className="col-xs-3">
              <label htmlFor="vertical-select">
                Vertical<span className="text-danger">*</span>
              </label>
              <select
                className="form-control"
                id="vertical-select"
                value={vertical}
                onChange={updateVertical}
                data-testid="vertical"
              >
                <option value="cm_cosmetics">Coman - Cosmetics</option>
                <option value="cm_food_and_bev">Coman - Food & bev</option>
                <option value="cm_household">Coman - Household</option>
                <option value="cm_personal_care">Coman - Personal care</option>
                <option value="cp_cosmetics">Copack - Cosmetics</option>
                <option value="cp_food_and_bev">Copack - Food & bev</option>
                <option value="cp_household">Copack - Household</option>
                <option value="cp_personal_care">Copack - Personal care</option>
              </select>
            </div>
          </div>

          <input
            type="button"
            value="Create Shop Floor Company"
            id="create_ops_core_company_button"
            className="btn btn-primary"
            disabled={disabled}
            onClick={createCompany}
          />
        </div>
      </div>
    </div>
  );
};

OpsCoreSetup.propTypes = {
  onExecute: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default OpsCoreSetup;
